module.exports = __webpack_public_path__ + "static/pink-arrow-right-4c54dc51b34d325b4c35c937287ebca9.png";